<template>
    <c-dialog ref="dialog" :title="'盘点-'+ detailData.check_user_name" mode="slide" width="50vw" enable-flex mask-close>
        <template #head>
            <div class="m-detail-tag flex-center-cross">
                <label class="inventory-code">{{detailData.check_code || '-'}}</label>
                <c-state tag async dict="INVENTORY_STATE" :value="detailData.check_state"></c-state>
            </div>
        </template>

        <c-form vertical unit-width="100%">
            <template v-if="step == 1">
                <c-title>盘点商品明细</c-title>
                <c-form-item :label="false">
                    <m-operate border>
                        <div class="m-scan-input-box">
                            <c-input ref="scanInput" v-model="scanCode" placeholder="请扫描/输入背贴码" @keyup.enter.native="scanProduct">
                                <template #appendIcon><i class="tf-scan"></i></template>
                            </c-input>
                        </div>
                        <c-button color="main" @click="scanProduct">确定</c-button>
                        <c-button color="red" :hollow="true" prepend-icon="tf-trash" @click="batchRemove">批量移除</c-button>
                    </m-operate>
                    <c-table key="inventory-products" ref="productTable" :data="productList" border :paging="false" @dataChange="selectProduct">
                        <c-table-column type="selector" width="32"></c-table-column>
                        <c-table-column label="产品信息" width="200">
                            <template #default="{data}">
                                <span v-if="data.level_type" class="m-tag" :style="getLevelStyle(data.level_type)">{{getLevelName(data.level_type)}}</span>
                                <span>{{getProductText(data)}}</span>
                            </template>
                        </c-table-column>
                        <c-table-column label="背贴码" width="150">
                            <template #default="{data}">
                                <span>{{data.produce_unique_code || '-'}}</span>
                            </template>
                        </c-table-column>
                        <c-table-column label="IMEI" width="150">
                            <template #default="{data}">
                                <span>{{data.produce_imei || '-'}}</span>
                            </template>
                        </c-table-column>
                        <c-table-column label="成本价" width="100">
                            <template #default="{data}">
                                <span>{{data.purchase_price ? '¥' + data.purchase_price : '-'}}</span>
                            </template>
                        </c-table-column>
                        <c-table-column label="当前接驳人" width="120">
                            <template #default="{data}">
                                <span>{{data.recipient_user_realname || '-'}}</span>
                            </template>
                        </c-table-column>
                        <c-table-column type="button" label="操作" width="80">
                            <template #default="{data, index}">
                                <c-table-button color="red" icon="tf-trash" @click="removeProduct(data, index)">移除</c-table-button>
                            </template>
                        </c-table-column>
                    </c-table>
                </c-form-item>
            </template>

            <!-- 步骤2：盘点确认 -->
            <template v-else>
                <c-title>盘点扫码记录</c-title>
                <c-form-item :label="false">
                    <c-table key="inventory-scan-records" ref="scanRecordTable" :data="productList" border :paging="false">
                        <c-table-column label="产品信息" width="200">
                            <template #default="{data}">
                                <span v-if="data.level_type" class="m-tag" :style="getLevelStyle(data.level_type)">{{getLevelName(data.level_type)}}</span>
                                <span>{{getProductText(data)}}</span>
                            </template>
                        </c-table-column>
                        <c-table-column label="背贴码" width="150">
                            <template #default="{data}">
                                <span>{{data.produce_unique_code || '-'}}</span>
                            </template>
                        </c-table-column>
                        <c-table-column label="IMEI" width="150">
                            <template #default="{data}">
                                <span>{{data.produce_imei || '-'}}</span>
                            </template>
                        </c-table-column>
                        <c-table-column :label="detailData.check_state != 3 ? '当前接驳人' : '接驳人'" width="120">
                            <template #default="{data}">
                                <span>{{data.recipient_user_realname || '-'}}</span>
                            </template>
                        </c-table-column>
                    </c-table>
                </c-form-item>

                <c-title class="section-title">盘点完成</c-title>
                <c-form-item :label="false">
                    <div class="post-area">
                        <div class="post-title">盘亏背贴码：<span class="post-count">{{profitLossList.length}}</span>条</div>
                        <template v-if="profitLossList.length">
                            <div class="loss-list">
                                <div class="loss-item" v-for="(item, index) in profitLossList" :key="item.produce_unique_code_id || index">
                                    <div class="loss-index-code">
                                        <span class="loss-index">{{index + 1}}.</span>
                                        <span class="loss-code">{{item.produce_unique_code || '-'}}</span>
                                    </div>
                                    <div class="loss-product">
                                        <span>{{getProductText(item)}}</span>
                                    </div>
                                    <div class="loss-lend">
                                        <span v-if="item.lend_state == 1" class="lend-mark">借出：{{item.lend_borrower_name || '-'}}</span>
                                        <span v-else-if="item.lend_state == 0" class="no-lend">未借出</span>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <div class="empty-hint" v-else>
                            <i class="tf tf-finish"></i>
                            <div class="name">无盘亏</div>
                        </div>
                        <div class="post-title profit-title">盘盈背贴码：<span class="post-count">{{profitList.length}}</span>条</div>
                        <template v-if="profitList.length">
                            <div class="loss-list profit-list">
                                <div class="loss-item" v-for="(item, index) in profitList" :key="item.produce_unique_code_id || index">
                                    <div class="loss-index-code">
                                        <span class="loss-index">{{index + 1}}.</span>
                                        <span class="loss-code">{{item.produce_unique_code || '-'}}</span>
                                    </div>
                                    <div class="loss-product">
                                        <span>{{getProductText(item)}}</span>
                                    </div>
                                    <div class="loss-remark">
                                        <span v-if="item.remark">{{item.remark}}</span>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <div class="empty-hint" v-else>
                            <i class="tf tf-finish"></i>
                            <div class="name">无盘盈</div>
                        </div>
                    </div>
                </c-form-item>
                <c-form-item label="备注">
                    <div v-if="detailData.check_state == 3" class="remark-text">{{postRemark || '-'}}</div>
                    <c-input v-else type="textarea" rows="4" v-model="postRemark" placeholder="备注内容填写在这里..." maxlength="500"></c-input>
                </c-form-item>
            </template>
        </c-form>

        <template #button>
            <template v-if="detailData.check_state != 3">
                <c-button v-if="step == 1" size="dialog" color="main" @click="nextStep">下一步</c-button>
                <c-button v-if="step == 2" size="dialog" @click="step = 1">上一步</c-button>
                <c-button v-if="step == 2" size="dialog" color="main" @click="confirmPost">盘点完成</c-button>
                <c-button size="dialog" @click="$refs.dialog.close()">取消</c-button>
            </template>
            <c-button v-else v-show="false" size="dialog" color="main" @click="$refs.dialog.close()">确认</c-button>
        </template>
    </c-dialog>
</template>

<script>
    export default {
        name: 'inventoryDetail',

        data() {
            return {
                checkId: '',
                step: 1,
                scanCode: '',
                postRemark: '',
                detailData: {},
                productList: [],
                profitLossList: [],
                profitList: [],
                selectedProductList: [],
                levelTypeOptions: [],
            }
        },
        mounted() {
            this.loadLevelOptions();
        },

        methods: {
            /*********加载等级选项**********/
            loadLevelOptions() {
                this.request({
                    url: '/dic/info/options',
                    data: {
                        dic_type_code: 'LEVEL_TYPE'
                    },
                    success: data => {
                        this.levelTypeOptions = data;
                    }
                });
            },
            /*********打开抽屉**********/
            open(id) {
                this.checkId = id;
                this.step = 1;
                this.scanCode = '';
                this.postRemark = '';
                this.productList = [];
                this.profitLossList = [];
                this.profitList = [];
                this.selectedProductList = [];
                this.loadDetail();
                this.$refs.dialog.open();
                this.$nextTick(() => {
                    this.focusInput();
                });
            },

            /*********聚焦扫码输入框**********/
            focusInput() {
                this.$nextTick(() => {
                    var input = this.$refs.scanInput && this.$refs.scanInput.$el && this.$refs.scanInput.$el.querySelector('input');
                    if (input) input.focus();
                });
            },

            /*********加载盘点任务详情**********/
            loadDetail() {
                this.request({
                    url: '/inventory/detail',
                    data: {id: this.checkId},
                    loading: true,
                    success: data => {
                        if (data.check_state == 3) {
                            this.step = 2;
                        }
                        this.postRemark = data.remark;
                        this.detailData = data || {};
                        this.productList = data.product_list || [];
                        this.profitLossList = data.profit_loss_list || [];
                        this.profitList = data.profit_list || [];
                    }
                });
            },

            /*********获取产品信息文字**********/
            getProductText(data) {
                var parts = [];
                if (data.brand_name) parts.push(data.brand_name);
                if (data.model_name) parts.push(data.model_name);
                // if (data.spu_model_name) parts.push(data.spu_model_name);
                if (data.color_name) parts.push(data.color_name);
                if (data.memory_name) parts.push(data.memory_name);
                return parts.join(' ') || '-';
            },

            /*********根据等级类型获取选项**********/
            getLevelOption(levelType) {
                return this.levelTypeOptions.find(item => item.value == levelType || item.level_type == levelType) || {};
            },

            /*********根据等级类型获取名称**********/
            getLevelName(levelType) {
                var option = this.getLevelOption(levelType);
                console.log(option)
                return option.name || option.dic_name || option.level_type_name || '';
            },

            /*********根据等级类型获取样式**********/
            getLevelStyle(levelType) {
                var option = this.getLevelOption(levelType);
                if (!option.color) return {};
                return {
                    color: option.color,
                    borderColor: option.color
                };
            },

            /*********扫码添加商品**********/
            scanProduct() {
                var code = this.scanCode.trim();
                if (!code) {
                    this.$message({message: '请输入背贴码', type: 'warn'});
                    return;
                }
                if (this.productList.some(item => item.produce_unique_code == code)) {
                    this.$message({message: '该背贴码已添加', type: 'warn'});
                    this.scanCode = '';
                    this.focusInput();
                    return;
                }
                this.request({
                    url: '/inventory/scan',
                    data: {
                        id: this.checkId,
                        code: code
                    },
                    loading: true,
                    success: (data) => {
                        this.scanCode = '';
                        this.productList.push(data);
                        this.$message({message: '扫描成功', type: 'success'});
                        this.focusInput();
                    },
                    fail: (msg) => {
                        this.$message({message: msg, type: 'warn'});
                        this.scanCode = ''
                        this.focusInput();
                    }
                });
            },

            /*********选中扫描商品**********/
            selectProduct() {
                this.selectedProductList = this.$refs.productTable.getData('selected') || [];
            },

            /*********移除商品**********/
            removeProduct(data, index) {
                this.$confirm({
                    message: '确认移除该商品？',
                    buttonName: '确定',
                    cancelButton: true,
                    resolve: () => {
                        this.request({
                            url: '/inventory/remove',
                            data: {
                                id: this.checkId,
                                ids: [data.id]
                            },
                            loading: true,
                            success: () => {
                                this.productList.splice(index, 1);
                                this.$message({message: '移除成功', type: 'success'});
                            }
                        });
                    }
                });
            },

            /*********批量移除商品**********/
            batchRemove() {
                if (!this.selectedProductList.length) {
                    this.$message({message: '请选择要移除的商品', type: 'warn'});
                    return;
                }
                var ids = this.selectedProductList.map(item => item.id);
                var idMap = {};
                this.selectedProductList.forEach(item => {
                    idMap[item.id] = true;
                });
                this.$confirm({
                    message: '确认移除选中的' + ids.length + '条商品？',
                    buttonName: '确定',
                    cancelButton: true,
                    resolve: () => {
                        this.request({
                            url: '/inventory/remove',
                            data: {
                                id: this.checkId,
                                ids: ids
                            },
                            loading: true,
                            success: () => {
                                this.productList = this.productList.filter(item => !idMap[item.id]);
                                this.selectedProductList = [];
                                this.$message({message: '移除成功', type: 'success'});
                            }
                        });
                    }
                });
            },

            /*********进入下一步**********/
            nextStep() {
                if (!this.productList.length) {
                    this.$message({message: '请先扫描盘点商品', type: 'warn'});
                    return;
                }
                this.loadProfitLoss();
            },

            /*********加载盘点盈亏数据**********/
            loadProfitLoss() {
                this.request({
                    url: '/inventory/loss',
                    data: {
                        id: this.checkId,
                        product_ids: this.productList.map(item => item.id)
                    },
                    loading: true,
                    success: data => {
                        this.step = 2;
                        this.profitLossList = data.loss_list || [];
                        this.profitList = data.profit_list || [];
                    }
                });
            },

            /*********确认盘点过账**********/
            confirmPost() {
                this.$confirm({
                    message: '确认盘点完成？完成后将不可修改盘点结果。',
                    buttonName: '确认完成',
                    cancelButton: true,
                    resolve: () => {
                        this.request({
                            url: '/inventory/post',
                            data: {
                                id: this.checkId,
                                remark: this.postRemark
                            },
                            loading: true,
                            success: (res, msg) => {
                                this.$message({message: msg, type: 'success'});
                                this.$emit('resolve');
                                this.$refs.dialog.close();
                            },
                            fail: (msg) => {
                                this.$message({message: msg, type: 'error'});
                            }
                        });
                    }
                });
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .lend-mark {
        color: #fa8c16;
        font-weight: 600;
    }

    .no-lend {
        color: #999;
    }

    .m-detail-tag {
        gap: 10px;

        .inventory-code {
            font-size: 13px;
            color: #666;
        }
    }

    .inventory-content {
        overflow: hidden;
        padding: 0 16px;
    }

    .scan-area {
        gap: 10px;
        padding: 16px 0;
        flex-shrink: 0;

        .m-scan-input-box {
            width: 260px;

            /deep/ .c-input input {
                background: #fffbe6;
            }
        }
    }

    .m-tag {
        display: inline-block;
        padding: 1px 6px;
        font-size: 12px;
        border-radius: 3px;
        margin-right: 4px;
        border: 1px solid currentColor;
    }

    .section {
        margin-bottom: 16px;

        .section-title {
            font-size: 14px;
            font-weight: 600;
            color: #333;
            padding: 12px 0 8px;
            border-bottom: 1px solid #eee;
            margin-bottom: 12px;
            flex-shrink: 0;
        }
    }

    .post-area {
        .post-title {
            margin-bottom: 16px;
            font-size: 14px;
            font-weight: 600;
            color: #333;

            .post-count {
                color: #f5222d;
            }
        }

        .loss-list {
            border: 1px solid #eee;
            border-radius: 4px;
            overflow: hidden;
            height: 320px;
            overflow-y: auto;

            &::-webkit-scrollbar {
                width: 6px;
            }

            &::-webkit-scrollbar-thumb {
                background: #c1c1c1;
                border-radius: 3px;
            }

            &::-webkit-scrollbar-track {
                background: #f1f1f1;
            }

            .loss-item {
                display: flex;
                align-items: center;
                padding: 14px 18px;
                color: #f5222d;
                font-size: 14px;

                &:nth-child(even) {
                    background: #fff1f0;
                }

                .loss-index-code {
                    flex-shrink: 0;
                    width: 160px;
                    display: flex;
                    align-items: center;
                    gap: 6px;
                }

                .loss-index {
                    width: 24px;
                }

                .loss-product {
                    flex: 1;
                    display: flex;
                    align-items: center;

                    .m-tag {
                        margin-right: 6px;
                    }
                }

                .loss-lend {
                    flex-shrink: 0;
                    margin-left: 12px;
                    font-size: 13px;
                }

                .loss-remark {
                    flex-shrink: 0;
                    margin-left: 12px;
                    font-size: 13px;
                }
            }
        }

        .profit-title {
            margin-top: 24px;
        }

        .profit-list {
            .loss-item {
                color: #1890ff;

                &:nth-child(even) {
                    background: #e6f7ff;
                }
            }
        }

        .empty-hint {
            padding: 40px 0;
            text-align: center;

            i {
                font-size: 48px;
                color: #52c41a;
            }

            .name {
                margin-top: 10px;
                font-size: 14px;
                color: #666;
            }
        }
    }

    .remark-area {
        margin-top: 24px;

        label {
            display: block;
            margin-bottom: 10px;
            font-size: 14px;
            color: #333;
        }

        .remark-text {
            font-size: 14px;
            color: #333;
            line-height: 1.6;
            white-space: pre-wrap;
            word-break: break-all;
        }

        /deep/ .c-input textarea {
            min-height: 96px;
        }
    }
</style>
